import { useEffect } from 'react'

/**
 * Al recargar (F5) la página siempre se empieza en el Hero:
 * desactiva la restauración de scroll del navegador, limpia el ancla de la URL
 * y sube al inicio sin animación.
 */
export function useResetScrollOnLoad(): void {
  useEffect(() => {
    if (typeof window === 'undefined') return

    const previous = window.history.scrollRestoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }

    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search)
    }

    const toTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    toTop()
    // Segundo intento tras el primer paint, por si el navegador restaura la posición.
    const raf = window.requestAnimationFrame(toTop)
    window.addEventListener('beforeunload', toTop)

    return () => {
      window.cancelAnimationFrame(raf)
      window.removeEventListener('beforeunload', toTop)
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = previous ?? 'auto'
      }
    }
  }, [])
}
